<div *ngIf="checkLength()" class="reward-heading">Rewards</div>
<mat-card *ngFor="let item of rewards" class="reward-container"
          [ngClass]="{'fr-ended': isFundraiserEnded || !item.status}"
          [matRippleDisabled]="isFundraiserEnded || !item.status" (click)="donateNow(item)" matRipple>
  <div *ngIf="!isFundraiserEnded" class="reward-amount">
    <span *ngIf="item.status">
      <!-- <mat-icon class="icon-rupee"></mat-icon> -->
      <app-currency-icon class="icon" *ngIf="currency" [currency]="currency"></app-currency-icon>
      {{item.amount | number:'1.0-0'}}
    </span>
    <span class="hide-reward-amount" *ngIf="!item.status">SOLD OUT</span>
  </div>
  <div class="line" *ngIf="!isFundraiserEnded"></div>
  <div *ngIf="isFundraiserEnded" class="hide-reward-amount">This fundraiser has ended!</div>
  <div class="line" *ngIf="isFundraiserEnded"></div>
  <div class="reward-title" [ngClass]="{'ended-reward-title': isFundraiserEnded}">{{item.descp}}</div>
  <div class="reward-content" [ngClass]="{'ended-reward': isFundraiserEnded}">
    <div class="r-desc" [innerHTML]="item.notes | safeHtml"></div>
    <div class="r-backers">
      <span *ngIf="item.backers>0">{{remainingBackers(item)}} rewards left | </span>
      {{item.active_backers_count}} Backers
    </div>
    <div class="r-date">Estimated Delivery : {{item.expected_date}}</div>
  </div>
  <app-progress-bar
    *ngIf="item.backers !== -99"
    [amount]="item.active_backers_count"
    [goal]="item.backers">
  </app-progress-bar>
  <div class="choose-text" *ngIf="!isFundraiserEnded">
    <span>Choose this reward</span>
  </div>
</mat-card>

<app-donate-now #donateNowBtn class="d-none" [isRewardSelected]="true"></app-donate-now>
